import { GraphQLClient } from "graphql-request";

const client = new GraphQLClient("https://api.stokefire.xyz/");

export const fetchVillageDetails = async () => {
  const query = `
    query MyQuery {
      villages (limit: 1000) {
        items {
          id
          food
          huts
          lumberCamps
          level
          score
          villagers
          villagersChopping
          villagersDefending
          villagersGathering
          villagersInLumberCamp
          villagersRaiding
          wood
          player {
            username
            pfp
          }
        }
      }
    }
  `;

  const data = await client.request(query);

  // Returning the village details
  return data.villages.items;
};
